import { useDownloadAttachment } from "@ext/agent/components/hooks/useDownloadAttachment";
import { useStoredAttachmentSrc } from "@ext/agent/components/hooks/useStoredAttachmentSrc";
import { FileAttachmentTile } from "@ext/agent/components/panel/FileAttachmentTile";
import { ImageAttachmentPreview } from "@ext/agent/components/panel/ImageAttachmentPreview";
import type { ChatAttachment } from "@ext/agent/core/attachmentStore";

export const SentImageAttachment = ({ attachment }: { attachment: ChatAttachment }) => {
	const { src, blob, failed } = useStoredAttachmentSrc(attachment);
	const { download, isDownloading } = useDownloadAttachment(attachment, blob);
	if (failed) return <FileAttachmentTile mime={attachment.mime} name={attachment.originalFilename} />;
	return (
		<ImageAttachmentPreview
			isDownloading={isDownloading}
			name={attachment.originalFilename}
			onDownload={download}
			src={src}
		/>
	);
};
